export default function Macros (pButton)
{
  this.preInitInsertEmailMacrosDialogButton = () =>
  {
    if (pButton.pGroup.pToolbar.tWindow.BonaDialog === undefined || !pButton.pGroup.pToolbar.tWindow.BonaDialog)
    {
      setTimeout(this.preInitInsertEmailMacrosDialogButton, 100);
      return;
    }

    pButton.pAttribute.Dialog = pButton.pGroup.pToolbar.tWindow.BonaDialog.createInnerWindow(pButton.pAttribute.id + '_Dialog', pButton.pAttribute.parameters);
  };
}